import React from 'react';
import styled from "styled-components"

export const DashboardGrid = styled.div`
  height: 95vh;
  width: 100vw;
  display: grid;
  grid-template-columns: 100vw;
  grid-template-rows: ${({gridRows}) => gridRows ? gridRows : '13.6rem 1fr 1fr'};
  
  .grid-header {
    background: ${({headerColor}) => headerColor ? headerColor : 'white'};
    color: ${({headerColor}) => headerColor ? 'white' : 'inherit'};
    padding-top: 3.6rem;
    padding-left: 3.6rem;
    padding-right: 3.6rem;
    
    > div {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }
  }
  
  .grid-top {
    padding-left: 3.6rem;
    padding-right: 3.6rem;
    background: ${({topColor}) => topColor ? topColor : 'white'};
  }
  
  .grid-bottom {
    background: ${({bottomColor}) => bottomColor ? bottomColor : 'white'};
    padding-left: 3.6rem;
    padding-right: 3.6rem;
    padding-bottom: 5rem;
    h5 {
      padding-top: 1rem;
      padding-bottom: 1rem;
      font-size: 3rem;
      color: #555555;
    }
  }
`